import React from 'react';
import { Link } from 'react-router-dom';
import { Star, ShoppingBag, ArrowUpRight } from 'lucide-react';
import { formatCurrency } from '../../lib/utils';

export default function ProductCard({ product }) {
  return (
    <Link 
      to={`/product/${product.id}`}
      className="deal-card block rounded-2xl group"
      data-testid={`product-card-${product.id}`}
    >
      {/* Image */}
      <div className="relative aspect-square overflow-hidden rounded-t-2xl bg-zinc-100">
        {product.image_url ? (
          <img 
            src={product.image_url} 
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <ShoppingBag size={40} className="text-zinc-300" />
          </div>
        )}
        
        {/* Category Badge */}
        <div className="absolute top-3 left-3 bg-white/90 backdrop-blur-sm px-2.5 py-1 rounded-full">
          <span className="text-xs font-medium text-zinc-700">{product.category}</span>
        </div>

        {/* Arrow on hover */}
        <div className="absolute top-3 right-3 w-8 h-8 bg-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <ArrowUpRight size={16} className="text-zinc-900" />
        </div>
      </div>
      
      {/* Content */}
      <div className="p-4">
        <p className="text-xs text-zinc-500 mb-1">by {product.vendor_name}</p>
        <h3 className="font-semibold text-zinc-900 truncate mb-2 group-hover:text-[#00aa55] transition-colors">
          {product.name}
        </h3>
        
        {/* Rating */}
        {product.reviews_count > 0 && (
          <div className="flex items-center gap-1 mb-2">
            <Star size={12} className="text-yellow-500 fill-yellow-500" />
            <span className="text-xs text-zinc-500">
              {product.rating.toFixed(1)} ({product.reviews_count})
            </span>
          </div>
        )}
        
        {/* Price */}
        <div className="flex items-center justify-between">
          <span className="font-display font-bold text-lg text-zinc-900">
            {formatCurrency(product.price)}
          </span>
          <span className="text-xs text-zinc-400">{product.inventory} in stock</span>
        </div>
      </div>
    </Link>
  );
}
